export type UserPermissionsType = {
    loading: boolean
    permissionsError: string
    permissions: [string] | []
}

export type UserPermissionErrorActionType = {
    type: string
    payload?: string
}

export type UserPermissionFetchActionType = {
    type: string
    payload?: [string]
}

export type UserPermissionsActionType =
    | UserPermissionErrorActionType
    | UserPermissionFetchActionType

export const UserPermissionSliceNames = {
    userPermissions: 'userPermissions',
    userPermissionsGet: 'userPermissions/get'
}
